var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { Paper, Grid, Button, makeStyles } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import Alert from '@material-ui/lab/Alert';
import { getItem } from '../../utils/LocalStorageUtil';
import { TOKEN_KEY } from '../../utils/StorageKeys';
import { forgotPassword } from '../../services/user-service';
import { InputGroup } from '../../components/common/input/input';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Logo from '../../assets/images/logo-b.png';
import * as Constant from '../../utils/Constant';
import { validate } from '../../utils/ValidationUtil';
var ForgotPassword = function (props) {
    var t = useTranslation().t;
    var classes = useStyles();
    var history = useHistory();
    var _a = useState(""), email = _a[0], setEmail = _a[1];
    var _b = useState(""), forgotSuccess = _b[0], setForgotSuccess = _b[1];
    var _c = useState(), forgotFailed = _c[0], setForgotFailed = _c[1];
    var _d = useState({
        email: ""
    }), errorList = _d[0], setErrors = _d[1];
    var validateOption = {
        email: {
            type: Constant.VALIDATION_TYPE_EMAIL,
            value: "",
            name: t("common.email")
        }
    };
    var isForgot = false;
    useEffect(function () {
        var token = getItem(TOKEN_KEY);
        if (token) {
            history.push("/dashboard");
        }
        return (function () {
            setForgotSuccess("");
            setForgotFailed(null);
            setEmail("");
        });
    }, []);
    var validateFormData = function () {
        var isValid = true;
        var validateData = __assign({}, validateOption);
        validateData.email.value = email || "";
        var error = validate(validateData);
        var errorValidate = __assign({}, errorList);
        if (Object.keys(error).length) {
            errorValidate = error;
            setErrors(errorValidate);
            isValid = false;
        }
        return isValid;
    };
    var validateForm = function (cbSave) {
        if (validateFormData()) {
            var errorDefault = {
                email: "",
            };
            setErrors(errorDefault);
            return cbSave();
        }
        return;
    };
    var onSubmitForgot = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            isForgot = true;
            validateForm(function () { return __awaiter(void 0, void 0, void 0, function () {
                var data, response_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 3, , 4]);
                            event.preventDefault();
                            if (!email) return [3 /*break*/, 2];
                            return [4 /*yield*/, forgotPassword({ email: email })];
                        case 1:
                            data = _a.sent();
                            isForgot = false;
                            setForgotSuccess("An email has been sent to your email address. Please click the link to reset your password.");
                            _a.label = 2;
                        case 2: return [3 /*break*/, 4];
                        case 3:
                            response_1 = _a.sent();
                            isForgot = false;
                            if (response_1) {
                                setForgotFailed(response_1 || "");
                            }
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
            return [2 /*return*/];
        });
    }); };
    var redirectLogin = function () {
        history.push("/login");
    };
    return (React.createElement("div", { className: classes.containerLogin },
        React.createElement(Grid, { container: true, spacing: 0, alignItems: "center", justify: "center" },
            React.createElement(Grid, { item: true, xs: 3 },
                React.createElement("div", { className: classes.loginLogo },
                    React.createElement("img", { className: classes.logo, src: Logo, alt: "logo" })),
                React.createElement("h3", { className: classes.loginTitle }, "Pubdesk Dashboard"),
                React.createElement(Paper, { className: classes.wraperLogin },
                    React.createElement("div", null,
                        forgotFailed && forgotFailed.message && !forgotSuccess && React.createElement(Alert, { severity: "error" }, forgotFailed.message || "Login Failed."),
                        forgotSuccess && React.createElement(Alert, { severity: "success" }, forgotSuccess),
                        !forgotSuccess ? React.createElement(Grid, { container: true, alignItems: "flex-end", className: classes.input },
                            React.createElement("p", { className: classes.forgotTitle }, t("accout_setting.title_forgot")),
                            React.createElement(InputGroup, { type: "text", iconName: "email", placeholder: "Email", value: email, onChange: function (text) { return setEmail(text); } }),
                            React.createElement("div", { className: "component-error-text" }, errorList && errorList.email ? errorList.email : "")) : null,
                        React.createElement(Grid, { container: true, alignItems: "center", justify: "space-between", className: classes.input },
                            React.createElement(Grid, { item: true },
                                React.createElement("button", { type: "button", className: "btn-pb-default-2", onClick: redirectLogin }, "Login")),
                            !forgotSuccess ? React.createElement(Grid, { item: true },
                                React.createElement(Button, { variant: "contained", color: "primary", onClick: onSubmitForgot, style: { textTransform: "none" }, disabled: isForgot }, "Reset")) : null)))))));
};
var useStyles = makeStyles(function (theme) { return ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    containerLogin: {
        marginRight: 'auto',
        marginLeft: 'auto',
        paddingLeft: 12,
        paddingRight: 12
    },
    loginLogo: {
        margin: '100px auto 50px',
        textAlign: 'center'
    },
    logo: {
        width: '100%'
    },
    loginTitle: {
        color: '#90a4ae',
        textAlign: 'center',
        marginTop: 16,
        marginBottom: 16,
        fontFamily: "'Open Sans', 'Droid Sans', Tahoma, Arial, sans-serif",
        fontSize: 24,
        fontWeight: 400
    },
    forgotTitle: {
        fontSize: "13px",
        paddingBottom: "15px",
        color: "#455a64"
    },
    wraperLogin: {
        padding: '20px 20px 35px 20px'
    },
    input: {
        padding: 10
    },
    labelInput: {
        fontSize: 14
    },
    icon: {
        color: '#455A64'
    }
}); });
function mapStateToProps(state) {
    return {};
}
export default connect(mapStateToProps)(ForgotPassword);
